import { usePermissions } from '@api/application-configuration';

/**
 * Returns whether a permission is granted.
 * @param permissionName The name of the permission to check.
 * @returns True if the permission is granted, false otherwise.
 */
export const usePermission = (permissionName: string): boolean => {
  const permissions = usePermissions();

  return permissions?.[permissionName] ?? false;
};
